export function groupBy<TYPE, KEY, VALUE>(items: Array<TYPE>, keyFunction: ((value: TYPE) => KEY),
                                          valueFunction: ((currentValue: VALUE | null | undefined, newValue: TYPE) => VALUE)): Map<KEY, VALUE> {
    const map = new Map<KEY, VALUE>();
    items.forEach((item) => {
        const key = keyFunction.call(null, item);

        if (!map.has(key)) {
            const value = valueFunction.call(null, null, item);
            map.set(key, value);
        } else {
            const currentValue = map.get(key);
            map.set(key, valueFunction.call(null, currentValue, item));
        }
    });
    return map;
}

export function zeroIfNull(value: number | undefined) {
    return value ?? 0;
}

export function access(value: unknown, path: string): unknown {
    if (path) {
        if (path.indexOf(".") != -1) {
            let search = value;
            path.split(".").forEach((property: string) => (search = (search as Record<string, unknown> | undefined)?.[property]));

            return search;
        } else {
            return (value as Record<string, unknown>)[path];
        }
    } else {
        return value;
    }
}

export default {
    groupBy<T, K = string>(items: Array<T>, keyGetter: (item: T) => K): Map<K, Array<T>> {
        const map = new Map<K, Array<T>>();
        items.forEach((item) => {
            const key = keyGetter(item);
            if (!map.has(key)) {
                map.set(key, [item]);
            } else {
                const collection = map.get(key) as Array<T>;
                collection.push(item);
            }
        });
        return map;
    },
    remove<T>(items: Array<T>, toRemove: T) {
        const indexToRemove = items.indexOf(toRemove);
        items.splice(indexToRemove, 1);
    },
    removeIfExists<T>(items: Array<T>, toRemove: T) {
        if (items.indexOf(toRemove) !== -1) {
            this.remove(items, toRemove);
        }
    },
    replaceIfExists<T>(items: Array<T>, source: T, target: T) {
        if (items.indexOf(source) !== -1) {
            this.remove(items, source);
            items.push(target);
        }
    },
    toCamelCase(value: string) {
        return value.replace(/([-_]\w)/g, g => g[1].toUpperCase());
    }
};
